import { motion } from 'motion/react';

export function DataCategoryCardSkeleton() {
  return (
    <div className="dashboard-reset bg-[#f0f5f6] box-border flex flex-col rounded-[10px] w-full gap-[9px] items-start pb-[35px] pt-0 px-0 lg:max-w-none">
      {/* Header with Icon and Status Skeleton */}
      <div className="box-border flex h-[60px] items-center justify-between pl-0 pr-[20px] py-0 w-full">
        {/* Icon Container Skeleton */}
        <div className="bg-white box-border flex gap-[10px] items-center justify-center p-[10px] rounded-br-[10px] rounded-tl-[10px] size-[60px] border border-[#d4c2b5] border-solid">
          <motion.div
            className="h-[30px] w-[29.285px] bg-gray-300 rounded"
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
          />
        </div>

        {/* Status Tag Skeleton */}
        <div className="flex gap-[5px] items-center">
          <motion.div
            className="bg-gray-300 h-[25px] w-[140px] rounded-[4px]"
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
          />
        </div>
      </div>

      {/* Body Content Skeleton */}
      <div className="box-border flex flex-col items-center w-full gap-[10px] lg:gap-[14px] px-[20px] lg:px-[64px] py-[5px] lg:py-0 lg:bg-gradient-to-r lg:from-[#f0f5f6] lg:to-[#f0f5f6] lg:rounded-[10px] flex-1">
        {/* Title and Progress Section Skeleton */}
        <div className="flex flex-col w-full gap-[7px] items-start">
          {/* Title Skeleton */}
          <motion.div
            className="bg-gray-300 h-[28px] w-[200px] rounded"
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
          />

          {/* Progress Section Skeleton */}
          <div className="flex flex-col items-start w-full gap-[4px]">
            {/* Progress Bar Skeleton */}
            <div className="w-full lg:w-[295px]">
              <motion.div
                className="bg-gray-300 rounded-[7.451px] h-[10px] w-full"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 0.6 }}
              />
            </div>

            {/* Progress Text Skeleton */}
            <motion.div
              className="bg-gray-300 h-[16px] w-[120px] rounded"
              animate={{ opacity: [0.5, 1, 0.5] }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 0.8 }}
            />
          </div>
        </div>

        {/* Description and Action Section Skeleton */}
        <div className="flex flex-col w-full gap-[24px] items-start lg:items-center">
          {/* Description Skeleton */}
          <div className="flex gap-[10px] items-center w-full justify-center">
            <div className="w-full lg:basis-0 lg:grow lg:min-h-px lg:min-w-px space-y-2">
              <motion.div
                className="bg-gray-300 h-[16px] w-full rounded"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 1.0 }}
              />
              <motion.div
                className="bg-gray-300 h-[16px] w-3/4 rounded"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 1.2 }}
              />
            </div>
          </div>

          {/* Button Skeleton */}
          <motion.div
            className="bg-gray-400 h-[40px] w-full lg:max-w-72 rounded-[100px]"
            animate={{ opacity: [0.5, 1, 0.5] }}
            transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 1.4 }}
          />
        </div>
      </div>
    </div>
  );
}

export default DataCategoryCardSkeleton;
